import { getItemHighlight, getSecondaryHighlight } from "./utils";

export function getInvoiceTemplate(item, html) {
  return html` <div class="aa-ItemWrapper">
    <div class="aa-ItemContent">
      <div class="aa-ItemIcon aa-ItemIcon--alignTop">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="receipt"
          class="svg-inline--fa fa-receipt "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
          height="24"
          width="24"
        >
          <path
            fill="currentColor"
            d="M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.2-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.2 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
          ></path>
        </svg>
      </div>
      <div class="aa-ItemContentBody">
        <div class="aa-ItemContentTitle">
          ${getItemHighlight(html, item, "invoice.invoice_number")}
          €${getItemHighlight(html, item, "invoice.total")}
          <!--              <span class="gsid text-success">ID: ${item.document
            .id}</span>-->
        </div>
        <div class="aa-ItemContentDescription">
          ${getSecondaryHighlight(html, item, "employee.email")}
          <br />Date: ${item.document["invoice.created"]} - Tax Cluster:
          ${item.document["invoice.tax_cluster"]}
          <span class="orgid label label-default"
            >Org ID: ${item.document["invoice.organisation_id"]}</span
          >
          <span class="text-danger ml-1">
            (${item.document["invoice.organisation_name"]})</span
          >
        </div>
      </div>
    </div>
  </div>`;
}
